import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getBlogById } from '../data/blogList';
import '../data/blog-styles.css';

const BlogPostPage = () => {
  const { id } = useParams();
  const post = getBlogById(id);

  if (!post) return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ 
          fontSize: '1.5rem', 
          fontWeight: 'bold', 
          color: '#1f2937', 
          marginBottom: '1rem' 
        }}>
          Article introuvable
        </h1>
        <Link 
          to="/" 
          style={{ 
            color: '#3b82f6', 
            textDecoration: 'none',
            fontSize: '1.125rem',
            fontWeight: '500'
          }}
        >
          ← Retour à l'accueil
        </Link>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{post.title} | Excellence Informatique</title>
        <meta name="description" content={post.description} />
        <meta name="keywords" content={`${post.category}, dépannage informatique, Nantes`} />
        <link rel="canonical" href={`https://mon-depannage-informatique.fr/blog/${post.id}`} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />
        <meta property="og:image" content={post.image} />
        <meta property="og:url" content={`https://mon-depannage-informatique.fr/blog/${post.id}`} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.description} />
        <meta name="twitter:image" content={post.image} />
      </Helmet>

      <div style={{
        backgroundColor: '#ffffff',
        color: '#1f2937',
        fontFamily: "'Poppins', 'Quicksand', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        minHeight: '100vh',
        width: '100%'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: 'clamp(1rem, 4vw, 2.5rem)',
          backgroundColor: '#ffffff'
        }}>
          <Link
            to="/blog"
            style={{
              color: '#3b82f6',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '2rem',
              fontSize: '1.125rem',
              fontWeight: '500',
              fontFamily: "'Quicksand', sans-serif"
            }}
          >
            ← Retour au blog
          </Link>

          {/* Container blog - sans bordures */}
          <div style={{
            backgroundColor: '#ffffff',
            color: '#1f2937',
            padding: '0',
            maxWidth: '1200px',
            margin: '0 auto',
            lineHeight: '1.6',
            fontFamily: "'Poppins', 'Quicksand', sans-serif"
          }}>
            {/* Header du blog */}
            <div style={{
              textAlign: 'center',
              marginBottom: '60px',
              paddingBottom: '40px',
              borderBottom: '1px solid #e5e7eb'
            }}>
              <h1 className="blog-main-title">
                {post.title}
              </h1>

              {(post.author || post.publishedAt || post.readingTime) && (
                <div className="blog-meta-info">
                  {post.author && (
                    <span className="blog-meta-author">
                      ✍️ Par {post.author}
                    </span>
                  )}
                  {post.publishedAt && (
                    <span className="blog-meta-date">
                      📅 {post.publishedAt}
                    </span>
                  )}
                  {post.readingTime && (
                    <span className="blog-meta-reading">
                      ⏱️ {post.readingTime}
                    </span>
                  )}
                </div>
              )}
            </div>
            
            {/* Contenu du blog */}
            <div
              className="blog-content-wrapper"
              style={{
                backgroundColor: '#ffffff',
                color: '#374151',
                fontFamily: "'Poppins', sans-serif"
              }}
              dangerouslySetInnerHTML={{
                __html: post.html
                  .replace(/<h1[^>]*>.*?<\/h1>/i, '')
                  .trim()
              }}
            />
          </div>

          {/* Call to Action en bas */}
          <div style={{
            marginTop: '3rem',
            textAlign: 'center'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
              borderRadius: '1rem',
              padding: '2rem',
              color: '#ffffff'
            }}>
              <h2 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                margin: '0 0 1rem 0'
              }}>
                💻 Besoin d'aide informatique ?
              </h2>
              <p style={{
                fontSize: '1.125rem',
                margin: '0 0 1.5rem 0',
                opacity: '0.9'
              }}>
                Nos techniciens sont à votre disposition pour tous vos besoins informatiques
              </p>
              <Link 
                to="/"
                style={{
                  backgroundColor: '#ffffff',
                  color: '#3b82f6',
                  fontWeight: '600',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  textDecoration: 'none',
                  display: 'inline-block',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                Contactez-nous
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPostPage;
